exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".ba-toolkit-select-compat{width:100%!important}.ba-toolkit-select-compat .bx--select-input{-webkit-appearance:none;width:100%!important}.ba-toolkit-select-compat .bx--select-input__wrapper{width:100%!important}", ""]);

// exports
